import React from 'react';
import { HeroSection } from './components/HeroSection';
import { IdentificationSection } from './components/IdentificationSection';
import { ProductPresentation } from './components/ProductPresentation';
import { WhatYouLearn } from './components/WhatYouLearn';
import { ModulesSection } from './components/ModulesSection';
import { PreviewSection } from './components/PreviewSection';
import { WorkplacesSection } from './components/WorkplacesSection';
import { TransformationSection } from './components/TransformationSection';
import { ProblemToolMap } from './components/ProblemToolMap';
import { OfferSection } from './components/OfferSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full min-h-screen bg-bg text-ink" data-id="element-0" data-mp="23vktwcepa1j4">
      <HeroSection data-id="element-1" data-mp="23v2tr4ox335x" />
      <IdentificationSection data-id="element-2" data-mp="23ti5txx3yih1" />
      <ProductPresentation data-id="element-3" data-mp="3ikr002qv3a7b" />
      <WhatYouLearn data-id="element-4" data-mp="3ijfwm41bw4gq" />
      <ModulesSection data-id="element-5" data-mp="3ihv2ugmu8pjx" />
      <PreviewSection data-id="element-6" data-mp="3mlj6wpc9h30f" />
      <WorkplacesSection data-id="element-7" data-mp="3mkrefndynled" />
      <TransformationSection data-id="element-8" data-mp="3mjzsl4a6121a" />
      <ProblemToolMap data-id="element-9" data-mp="3mj6hxs835sdv" />
      <OfferSection data-id="element-10" data-mp="3rcj31sdk3h1v" />
      <GuaranteeSection data-id="element-11" data-mp="3rdaquh0wwahl" />
      <FAQSection data-id="element-12" data-mp="3rcsulke91w9o" />
      <FinalCTA data-id="element-13" data-mp="3recc1ebn6dd1" />
      <Footer data-id="element-14" data-mp="5yh2n2cyzbp" />
    </div>;
}